<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.or_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="or_custname">
            <label class="weui-form-preview__label">{{
              customLabel.or_custname || "客户名称"
            }}</label>
            <em class="weui-form-preview__value">{{
              form.main.or_custname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="or_kind">
            <label class="weui-form-preview__label">{{
              customLabel.or_kind || "调账类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.or_kind
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="or_seller">
            <label class="weui-form-preview__label">{{
              customLabel.or_seller || "业务员"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.or_seller }}
              <!-- <call-mobile :em-id="form.main.pp_buyerid"></call-mobile> -->
            </span>
          </div>
          <div class="weui-form-preview__item" slot="or_date">
            <label class="weui-form-preview__label">{{
              customLabel.or_date || "单据日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(form.main.or_date, 'yyyy-MM-dd')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="or_currency">
            <label class="weui-form-preview__label">{{
              customLabel.or_currency || "币种"
            }}</label>
            <span class="weui-form-preview__value">
              {{ form.main.or_currency }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="or_beforeamount">
            <label class="weui-form-preview__label">{{
              customLabel.or_beforeamount || "应收余额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.or_beforeamount, '¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="or_afteramount">
            <label class="weui-form-preview__label">{{
              customLabel.or_afteramount || "调账后应收余额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.or_afteramount, '¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="or_paydate">
            <label class="weui-form-preview__label">{{
              customLabel.or_paydate || "应收日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(form.main.or_paydate, 'yyyy-MM-dd')
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pp_text1 || '自定义字段1'"
          v-model="form.main.pp_text1" slot="pp_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text2 || '自定义字段2'"
          v-model="form.main.pp_text2" slot="pp_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text3 || '自定义字段3'"
          v-model="form.main.pp_text3" slot="pp_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text4 || '自定义字段4'"
          v-model="form.main.pp_text4" slot="pp_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text5 || '自定义字段5'"
          v-model="form.main.pp_text5" slot="pp_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.ord_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="osd_caname">
              <label class="weui-form-preview__label">{{
                customLabel.ord_caname || "调账科目"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.ord_cacode }} {{ item.ord_caname }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="ord_nowbalance">
              <label class="weui-form-preview__label">{{
                customLabel.ord_nowbalance || "调账金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.ord_nowbalance, "#,##0.00")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ord_remark">
              <label class="weui-form-preview__label">{{
                customLabel.ord_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.ord_remark
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.ppd_text1 || '自定义字段1'"
            v-model="item.ppd_text1" slot="ppd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text2 || '自定义字段2'"
            v-model="item.ppd_text2" slot="ppd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text3 || '自定义字段3'"
            v-model="item.ppd_text3" slot="ppd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text4 || '自定义字段4'"
            v-model="item.ppd_text4" slot="ppd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text5 || '自定义字段5'"
            v-model="item.ppd_text5" slot="ppd_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.or_remark">
            <label class="weui-form-preview__label">调账原因</label>
            <span class="weui-form-preview__value">{{
              form.main.or_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.creatorName">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.or_auditman">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.or_auditman
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";
import CustomField from "@/components/field/CustomField.vue";
// import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    CustomField
    // CallMobile,
  },
  data() {
    return {
      baseUrl: "/api/money/othreceivables",
      caller: "OthReceivables",
      xtype: "money-othreceipts-formpanel",
    };
  },
};
</script>